'use strict';
define('domBids',['jquery', 'settings', 'translations', 'codes', 'util'],
	function ($, settings, T, codes, Util) {
		var domElements = [],
			bets = [],
			totalBets = [],
			preventSliding = true,
			roller,
			popularBets = [
				'lucky7.sum.more_150_5',
				'lucky7.sum.more_175_5',
				'lucky7.sum.more_200_5',
				'lucky7.sum.less_150_5',
				'lucky7.sum.less_125_5',
				'lucky7.sum.less_100_5',
				'lucky7.balls.black_less_73_5',
				'lucky7.balls.yellow_less_73_5',
				'lucky7.numbers.two_drop',

				'lucky6.numbers.one_drop_zone_a',
				'lucky6.numbers.one_drop_zone_b',
				'lucky6.numbers.one_drop_zone_c',
				'lucky6.numbers.two_drop_zone_a',
				'lucky6.numbers.two_drop_zone_b',
				'lucky6.numbers.two_drop_zone_c',
				'lucky6.sum.less_15_5',
				'lucky6.sum.less_26_5',
				'lucky6.sum.less_38_5',

				'lucky5.color.red_more_than_green',
				'lucky5.numbers.one_drop',
				'lucky5.numbers.two_drop',
				'lucky5.numbers.three_drop',
				'lucky5.numbers.more_even',
				'lucky5.numbers.more_92_5',
				'lucky5.numbers.sum_even',
				'lucky5.numbers.sum_odd',
				'lucky5.color.atleast_three_same_color',

				'dice.combinations.atleast_one_pair',
				'dice.combinations.any_two_pairs',
				'dice.combinations.three_any_kind',
				'dice.combinations.sequence_1_5',
				'dice.combinations.sequence_2_6',
				'dice.combinations.all_different',
				'dice.oddeven.more_even',
				'dice.oddeven.more_odd',
				'dice.oddeven.all_even',
				'dice.oddeven.all_odd',

				'diceDuel.main.blue_wins',
				'diceDuel.main.draw',
				'diceDuel.main.red_wins',
				'diceDuel.numbers.chosen_blue_roll',
				'diceDuel.numbers.chosen_red_blue_combination',
				'diceDuel.numbers.chosen_red_roll',
				'diceDuel.oddeven.blue_even',
				'diceDuel.oddeven.blue_odd',
				'diceDuel.oddeven.red_even',
				'diceDuel.oddeven.red_odd',
				'diceDuel.oddeven.sum_odd'
			];

		function init(dom, betList, gameNo, roll) {
			domElements[gameNo] = dom;
			bets[gameNo] = betList;
			totalBets[gameNo] = 0;
			roller = roll;

			_generatePopularOdds(gameNo);
			_generateAllOdds(gameNo);
		}

		function startSlider() {
			if (!preventSliding) {
				return;
			}
			preventSliding = false;

			settings.games.forEach(function (game, i) {
				_pageSlider(0, i);
				_historySlider(0, i);
			});
		}

		function stopSlider() {
			preventSliding = true;
		}

		function _generatePopularOdds(gameNo) {
			var popularOddsHtml = '',
				gameName = settings.getGameName(gameNo),
				popularOddsList = [],
				visibleOdds = {
					lucky7: 9,
					lucky6: 9,
					lucky5: 9,
					dice: 9,
					diceDuel: 9,
					poker: 9
				},
				oddsList = bets[gameNo];

			if (settings.games.length >= 2) {
				return; // Split screen does not have popular odds
			}

			// Generate popular odds list
			if (gameName === 'wheel' || gameName === 'rng-wheel') {
				popularOddsList = oddsList;
			}
			if (gameName === 'poker') {
				popularOddsList = bets[gameNo]
					.filter(odd => odd.name.includes('hands'))
					.sort((oddObjX, oddObjY) => oddObjX.code - oddObjY.code);
			} else {
				popularOddsList = oddsList.filter(function (item) {
					return popularBets.indexOf(item.name) > -1 || item.bid > 0;
				});
			}

			if (gameName !== 'poker') {
				// Sort list by bid size (DESC) OR possition (ASC) in array OR code DESC
				popularOddsList.sort(function (a, b) {
					return b.bid - a.bid ||
						popularBets.indexOf(a.name) - popularBets.indexOf(b.name) ||
						b.code - a.code;
				});
			}

			// Reduce size of array
			popularOddsList.length = gameName === 'wheel' || gameName === 'rng-wheel' ?
				popularOddsList.length : visibleOdds[gameName];

			popularOddsList.forEach(function (item) {
				var formattedElement = _formatBetElement(item, gameNo);

				popularOddsHtml += formattedElement;
			});

			if (gameName === 'poker') {
				domElements[gameNo].odds.popular.addClass('poker')
				domElements[gameNo].odds.all.addClass('poker')
				domElements[gameNo].odds.popular.find('.odd-container').addClass('poker')
			}

			domElements[gameNo].odds.popular.find('.odd-container').html(popularOddsHtml);
		}

		function _generateAllOdds(gameNo) {
			var allOddsHtml = '',
				gameName = settings.getGameName(gameNo),
				perPage = 9,
				current = 1,
				pages = 0,
				oddsList;

			// Generate all odds
			oddsList = bets[gameNo]
			if (gameName === 'poker' ) {
				perPage = 10,
				current = 0,
				oddsList = bets[gameNo].filter(odd => odd.name.includes('combinations'));
			}

			oddsList.forEach(function (odds, i) {
				const startFromIndex = gameName === 'poker' ? 0 : 1;
				if (current === startFromIndex) {
					pages++;
					allOddsHtml += '<div class="page col" ' + (pages === 1 ? 'data-active="true"' : '') + '>';
				}
				allOddsHtml += _formatBetElement(odds, gameNo);
				if (current === perPage || (i + 1) === oddsList.length) {
					current = 0;
					allOddsHtml += '</div>';
				}
				current++;
			});

			if (gameName === 'poker') {
				domElements[gameNo].odds.popular.addClass('poker');
				domElements[gameNo].odds.all.addClass('poker');
				domElements[gameNo].odds.all.find('.odd-container').addClass('poker');
			}

			domElements[gameNo].odds.all.find('.odd-container').html(allOddsHtml);
			domElements[gameNo].odds.available = domElements[gameNo].odds.both.find('[data-odd]');
		}

		function _formatBetElement(bet, gameNo) {
			var code = codes[bet.name],
				name = T.translate(bet.name),
				stake;

			stake = Object.prototype.hasOwnProperty.call(bet, 'bid') && bet.bid > 0 ?
				'<div class="odd-stake" data-active="true">' +
				Util.formatBid(bet.bid, gameNo) +
				'</div>' :
				'<div class="odd-stake"></div>';

			const gameName = settings.getGameName(gameNo);
			const isPokerGame = gameName === 'poker';
			const isBetLocked = !bet.isEnabled;
			const lockImg = '<img src="images/lock.svg"/>'
			const oddsHtml = isPokerGame && isBetLocked ? '<div class="odd-no highlight">' + lockImg + '</div>' :
				'<div class="odd-no highlight">' + (bet.formattedOdd ? bet.formattedOdd : Util.formatOdd(bet.odd)) + '</div>';


			return '<div class="odd-row" data-odd="' + code + '">' +
				'<div class="odd-code">' + code + '</div>' +
				'<div class="odd-title">' + name + '</div>' +
				stake +
				oddsHtml
				+ '</div>';
		}

		function _pageSlider(page, gameNo) {
			const pages = domElements[gameNo].odds.all.find('.odd-container').find('.page');
			const pager = domElements[gameNo].odds.all.find('.current-page');
			const nextPageNo = pages.length - 1 > page ? page + 1 : 0;
			const lastPage = page - 1 < 0 ? pages.length - 1 : page - 1;
			const gameName = settings.getGameName(gameNo);
			const isPokerGame = gameName === 'poker';

			if (isPokerGame) {
				return;
			}

			if (preventSliding) {
				pages.each(function () {
					$(this).removeClass('show').removeClass('hide');
				});
				return;
			}

			if (settings.games.length > 1) {
				if (pages.eq(lastPage).hasClass('show')) {
					pages.eq(lastPage).removeClass('show').addClass('hide');
				}

				domElements[gameNo].odds.pageNo
					.html(T.translate('translate_page') + ' ' + (page + 1) + '/' + pages.length);

				domElements[gameNo].odds.pageBar.css({
					'transition-duration': (settings.local.changeSpeed / 1000) + 's'
				});

				pages.eq(page).removeClass('hide').addClass('show');
				domElements[gameNo].odds.pageBar.removeClass('showFull');
				setTimeout(function () {
					domElements[gameNo].odds.pageBar.addClass('showFull');
				}, 50);

				setTimeout(function () {
					_pageSlider(nextPageNo, gameNo);
				}, settings.local.changeSpeed);
			} else {
				pager.css({ top: 0 }).animate({ height: '100%' }, 50, 'linear', function () {
					var current = pages.filter('[data-active="true"]'),
						next = pages.eq(page);

					current.attr('data-active', false).hide();

					next.attr('data-active', true).show();
					domElements[gameNo].odds.pageNo
						.html(T.translate('translate_page') + ' ' + (page + 1) + '/' + pages.length);
					domElements[gameNo].odds.pageBar.css({ width: 0 })
						.animate({ width: '100%' }, settings.local.changeSpeed, 'linear');

					setTimeout(function () {
						pager.css({ bottom: 0, top: 'auto' })
							.animate({ height: 0 }, 50, 'linear').children().css({ top: 'auto' });
					}, 50);
					setTimeout(function () {
						_pageSlider(nextPageNo, gameNo);
					}, settings.local.changeSpeed);
				}).children().css({ top: '' });
			}
		}

		function _historySlider(pageNo, gameNo) {
			var results = domElements[gameNo].results.latest,
				history = domElements[gameNo].results.historySection,
				pages = [results, history],
				nextPageNo = pageNo + 1 >= pages.length ? 0 : pageNo + 1,
				lastPage = pageNo - 1 < 0 ? pages.length - 1 : pageNo - 1;

			if (preventSliding || settings.games.length < 2) {
				return;
			}
			pages[lastPage].animate({ opacity: 0 }, 300, 'linear');

			setTimeout(function () {
				pages[pageNo].animate({ opacity: 1 }, 300, 'linear');
			}, 500);
			setTimeout(function () {
				_historySlider(nextPageNo, gameNo);
			}, settings.local.changeSpeed);
		}

		function updateBids(data, gameNo) {
			var bidSum = 0,
				bids = Object.keys(data).reduce(function (all, bidName) {
					var splittedBid = bidName.indexOf('|'),
						name = bidName.substring(0, splittedBid > 0 ? splittedBid : bidName.length),
						code = codes[name],
						bid = data[bidName];

					all[code] = all[code] + bid || bid;
					return all;
				}, {});

			bets[gameNo].forEach(function (item) {
				item.bid = bids[item.code] || 0;
			});

			Object.keys(bids).forEach(function (code) {
				var formattedNumber = Util.formatBid(bids[code], gameNo);

				bidSum += bids[code];
				domElements[gameNo].odds.available.filter('[data-odd=' + code + ']')
					.find('.odd-stake').attr('data-active', true)
					.html(formattedNumber);
			});

			if (bidSum !== totalBets[gameNo]) {
				roller.addToQueue(domElements[gameNo].header.stake, totalBets[gameNo], bidSum);
				totalBets[gameNo] = bidSum;
			}

			if (bidSum === 0) {
				totalBets[gameNo] = bidSum;
			}

			_generatePopularOdds(gameNo);
		}

		function resetBids(gameNo) {
			domElements[gameNo].odds.available.each(function () {
				$(this).find('.odd-stake').attr('data-active', false);
			});

			roller.addToQueue(domElements[gameNo].header.stake, totalBets[gameNo], 0);
			totalBets[gameNo] = 0;
			// Reset bids
			bets[gameNo].forEach(function (item) {
				item.bid = 0;
			});
			_generatePopularOdds(gameNo);
		}

		function lockBets(gameNo) {
			const gameName = settings.getGameName(gameNo);

			if (gameName !== 'poker') {
				return;
			}

			if (bets[gameNo].every(bet => !bet.isEnabled)) {
				return;
			}

			bets[gameNo] = bets[gameNo].map(bet => {
				return Object.assign(bet, { isEnabled: false })
			});

			_generatePopularOdds(gameNo);
			_generateAllOdds(gameNo);
		}

		return {
			initialize: init,
			startSlider: startSlider,
			stopSlider: stopSlider,
			updateBids: updateBids,
			resetBids: resetBids,
			lockBets: lockBets
		};
	}
);

